const ENDPOINTS = {
  // authentication
  ADMIN_LOGIN: "/api/admin/login",
  GET_PROFILE: "/api/admin/profile",
  PROFILE_UPDATE: "/api/admin/updateProfile",
  CHANGE_PASSWORD: "/api/admin/changePassword",

  // AGRONOMISTS
  ADD_AGRONOMISTS: "/api/admin/agronomist/add",
  AGRONOMISTS_LISTING: "/api/admin/agronomist/agronomistList",
  AGRONOMISTS_DETAIL: "/api/admin/agronomist/agronomistDetail",
  AGRONOMISTS_EDIT: "/api/admin/agronomist/agronomistEdit",
  AGRONOMISTS_STATUS: "/api/admin/agronomist/agronomistChangeStatus",
  AGRONOMISTS_DELETE: "/api/admin/agronomist/agronomistDelete",

  // PRODUCT
  ADD_PRODUCT: "/api/admin/product/addProduct",
  PRODUCT_LISTING: "/api/admin/product/productList",
  PRODUCT_DETAIL: "/api/admin/product/productDetail",
  PRODUCT_EDIT: "/api/admin/product/productEdit",
  PRODUCT_STATUS: "/api/admin/product/productChangeStatus",
  PRODUCT_DELETE: "/api/admin/product/productDelete",

  // CONTAINER TYPE
  CONTAINER_TYPE_LIST: "/api/admin/ContainerType",
  ADD_CONTAINER_TYPE: "/api/admin/ContainerType",
  UPDATE_CONTAINER_TYPE: (id) => `/api/admin/ContainerType/${id}`,
  DELETE_CONTAINER_TYPE: (id) => `/api/admin/ContainerType/${id}`,

  //CONTAINER UNIT
  CONTAINER_UNIT_LIST: "/api/admin/unitType",
  ADD_CONTAINER_UNIT: "/api/admin/unitType",
  UPDATE_CONTAINER_UNIT: (id) => `/api/admin/unitType/${id}`,
  DELETE_CONTAINER_UNIT: (id) => `/api/admin/unitType/${id}`,

  // RATE UNIT
  RATE_UNIT_LIST: "/api/admin/rate-unit",
  ADD_RATE_UNIT: "/api/admin/rate-unit",
  UPDATE_RATE_UNIT: (id) => `/api/admin/rate-unit/${id}`,
  DELETE_RATE_UNIT: (id) => `/api/admin/rate-unit/${id}`,

  // GROWER
  ADD_GROWER: "/api/admin/grower/add",
  GROWER_LISTING: "/api/admin/grower/growerList",
  GROWER_DETAIL: "/api/admin/grower/growerDetail",
  GROWER_EDIT: "/api/admin/grower/growerEdit",
  GROWER_STATUS: "",
  GROWER_DELETE: "/api/admin/grower/growerDelete",

  // CONTENT
  ADD_CONTENT: "/api/admin/content/updateContent",
  CONTENT_GET: "/api/common/content",

  // CROP
  ADD_CROP: "/api/admin/crop/addCrop",
  CROP_LISTING: "/api/admin/crop/cropList",
  CROP_DETAIL: "/api/admin/crop/cropDetail",
  CROP_EDIT: "/api/admin/crop/cropEdit",
  CROP_STATUS: "/api/admin/crop/cropChangeStatus",
  CROP_DELETE: "/api/admin/crop/cropDelete",

  // SCOUTING
  // ADD_SCOUTING: "/api/agronomist/grower/fields/addScouting",
  SCOUTING_LIST: "/api/admin/grower/fields/scoutingList",
  SCOUTING_DETAIL: "/api/admin/grower/fields/scouting/detial",
  // SCOUTING_DELETE: "/api/agronomist/grower/fields/scoutingDelete",
  // SCOUTING_EDIT: "/api/agronomist/grower/fields/editScouting",

  // DASHBOARD
  DASHBOARD: "/api/admin/dashboard",

  SEASON_YEARS_LIST: "/api/admin/seasons/dropDown/list",

  CROP_PLANE_SEASON_LIST: "/api/admin/cropPlan/season/list",
  CROP_PLAN_DETAIL: "/api/admin/cropPlan/season/details",
};

export default ENDPOINTS;
